<template>
  <div class="l-learn-card-container l-learn-exam-wrapper" v-if="element">
    <div class="l-learn-card-wrapper l-learn-content-container l-back-wrapper l-learn-exam-top">
      <!-- 红绿灯 -->
      <img
        v-if="answerList.length != element.totalCount"
        src="./images/red-left.png"
        class="l-learn-color-img left"
      />
      <img v-else src="./images/green-left.png" class="l-learn-color-img left" />
      <img
        v-if="answerList.length != element.totalCount"
        src="./images/red-right.png"
        class="l-learn-color-img right"
      />
      <img v-else src="./images/green-right.png" class="l-learn-color-img right" />

      <!-- 答题卡 -->
      <div class="l-learn-card-main">
        <div class="l-learn-card-title">答题卡</div>
        <div class="l-learn-card-btn-container">
          <div
            class="l-learn-card-btn"
            :class="{
            enable: index <= answerList.length,
            will: index == answerList.length + 1,
            unable: index > answerList.length + 1,
          }"
            v-for="index of element.totalCount"
            :key="index"
            @click="onGoQuestion(index)"
          >
            <span class="l-learn-card-btn-main">{{ index }}</span>
          </div>
        </div>
      </div>
      <!-- label -->
      <div class="l-learn-card-label-container">
        <div class="l-learn-card-label" v-for="(item, index) in labelList" :key="index">
          <span class="l-learn-card-label-icon" :class="item.status"></span>
          {{ item.name }}
        </div>
      </div>
      <!-- number -->
      <LNumber
        :current="examIndex + 1"
        :total="element.totalCount"
        :myclass="'test'"
        class="l-learn-number"
      />
      <!-- time -->
      <LTime :time="time" class="l-learn-time" />

      <!-- 按钮 -->
      <div class="l-learn-exam-btn-container l-learn-exam-bottom">
        <!-- <button type="button" class="l-btn-common gray" @click="onGoQuestion()">
          <span class="l-btn-text">{{ $locale.返回 }}</span>
        </button>-->
        <button
          type="button"
          class="l-btn-common default"
          v-if="answerList.length != element.totalCount"
          @click="onGoQuestion()"
        >
          <span class="l-btn-text">{{ $locale.继续闯关 }}</span>
        </button>
        <button type="button" class="l-btn-common correct" v-else @click="onSubmit">
          <span class="l-btn-text">{{ $locale.提交 }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import LNumber from '../../../../components/l-number'
import LTime from '../../../../components/l-time'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('course')

export default {
  name: 'l-learn-card',
  components: { LNumber, LTime },
  props: {
    answerList: {
      type: Array,
    },
    time: {
      type: String,
    },
  },
  data() {
    return {
      examIndex: 1,
      labelList: [
        {
          status: 'enable',
          name: '已完成',
        },
        {
          status: 'will',
          name: '进行中',
        },
        {
          status: 'unable',
          name: '未开始',
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['element']),
  },
  created() {
    this.examIndex =
      this.element.totalCount == this.answerList.length
        ? this.answerList.length - 1
        : this.answerList.length // 默认该答题题号
  },
  methods: {
    // 跳转到答题
    onGoQuestion(index) {
      if (index > this.answerList.length + 1) return
      this.$emit('jump', index ? index - 1 : null)
    },
    // 提交
    onSubmit() {
      this.$emit('submit')
    },
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>

